import { filter } from 'rxjs';
function isNotNullish(value) {
  switch (value) {
    case null:
    case undefined:
      {
        return false;
      }
    default:
      {
        return true;
      }
  }
}
function isNullish(value) {
  return !isNotNullish(value);
}
function isJSType(value, type) {
  return typeof value === type;
}
function isObject(obj) {
  return String(obj) === '[object Object]' && !Array.isArray(obj);
}
function isEveryJSType(type, ...values) {
  return values.every(v => isJSType(v, type));
}
function isInstance(value, constructor) {
  return value instanceof constructor;
}
function isEqual(v1, v2) {
  return Object.is(v1, v2);
}
function isEqualJSON(v1, v2) {
  return Boolean(v1) && Boolean(v2) && JSON.stringify(v1) === JSON.stringify(v2);
}
function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}
function arraysIsContain(searchElement, ...arrays) {
  return arrays.some(arr => arr.includes(searchElement));
}
function isDate(value) {
  return !Number.isNaN(Date.parse(value));
}
function condition(conditionValue, ifValue, elseValue) {
  return conditionValue ? ifValue : elseValue;
}
function isWritableSignal(signal) {
  return Boolean(signal.asReadonly);
}
function isExistAllObjectFields(obj, keys) {
  return keys.every(k => k in obj);
}
function isExistSomeFieldInObject(obj, keys) {
  return keys.some(k => k in obj);
}
function deepCopy(object) {
  if (!isObject(object)) {
    throw new Error(`Value: ${String(object)} can only be an object`);
  }
  const cloning = {};
  Object.keys(object).map(prop => {
    const value = object[prop];
    if (Array.isArray(value)) {
      cloning[prop] = value.concat().map(item => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return isObject(item) ? deepCopy(item) : Array.isArray(item) ? deepCopyArray(item) : item;
      });
    } else if (isObject(value)) {
      cloning[prop] = deepCopy(value);
    } else cloning[prop] = value;
  });
  return cloning;
}
function deepCopyArray(arr) {
  if (!Array.isArray(arr)) {
    throw new Error(`Value: ${arr} can only be an array`);
  }
  return arr.map(item => {
    return isObject(item) ? deepCopy(item) : Array.isArray(item) ? deepCopyArray(item) : item;
  });
}
function getDataFromDB(db, keys, copy = true) {
  const result = keys.reduce((accum, key) => {
    return accum[key];
  }, db);
  if (!copy) {
    return result;
  }
  const copyResult = isObject(result) ? deepCopy(result) : Array.isArray(result) ? deepCopyArray(result) : result;
  return copyResult;
}
function ofType(...actions) {
  return filter(action => actions.includes(action));
}

/* eslint-disable @typescript-eslint/prefer-reduce-type-parameter */
function titlecase(str) {
  const firstLetter = str[0].toUpperCase();
  const nextSymbols = str.slice(1);
  return firstLetter + nextSymbols;
}
function prefix(str, tag) {
  return `${tag}${String(str)}`;
}
function addPrefixIfNot(str, prefixStr) {
  if (!str || !prefixStr) return str;
  const isContainPrefix = str.startsWith(prefixStr);
  return isContainPrefix ? str : prefix(str, prefixStr);
}
function replace(str, from, to, flags = 'gi') {
  const reg = new RegExp(`${from}`, flags);
  return str.replace(reg, String(to));
}
function suffix(str, tag) {
  return `${String(str)}${tag}`;
}
function trim(str) {
  if (isJSType(str, 'string')) {
    return str.replace(/\s+/g, ' ').trim();
  }
  return str;
}
function removeSpaces(str) {
  if (isJSType(str, 'string')) {
    return str.replace(/\s+/g, '').trim();
  }
  return str;
}
function trimStringValues(obj, removeValSpaces = false) {
  const trimMethod = removeValSpaces ? removeSpaces : trim;
  return Object.entries(obj).reduce((accum, [key, value]) => {
    const isString = isJSType(value, 'string');
    accum[key] = isString ? trimMethod(value) : value;
    return accum;
  }, {});
}
function joinUrl(args, separator = '/') {
  return args.join(separator);
}
function wrapString(str, startWith, endWith = startWith) {
  return `${startWith}${str}${endWith}`;
}
function testIncludeWord(str, word) {
  const regexp = new RegExp(`\\b${word}\\b`);
  return regexp.test(str);
}
function lowercase(str) {
  return isJSType(str, 'string') ? str.toLocaleLowerCase() : str;
}
function isEqualStrings(str1, str2) {
  const isExistStrings = isJSType(str1, 'string') && isJSType(str2, 'string');
  if (isExistStrings) {
    return str1.toLowerCase() === str2.toLowerCase();
  }
  return false;
}
function sliceStringToSegments(str, segmentsLength = 2) {
  const segments = [];
  const splittedArray = str.split('');
  while (splittedArray.length > 0) {
    const segment = splittedArray.splice(0, segmentsLength).join('');
    segments.push(segment);
  }
  return segments;
}
function removeSymbols(str, symbols) {
  const symbolsRegex = new RegExp('', 'gi');
  const parsedSymbols = symbols.replace(symbolsRegex, '\\').replace(/\\$/, '');
  const regex = new RegExp(`[${parsedSymbols}]`, 'gi');
  return str.replace(regex, '');
}
function removeSideSymbols(str, count) {
  return str.slice(count).slice(0, str.length - (count + count));
}
function DIProvider(provide, value, use = 'class', multi = true) {
  const useKey = `use${titlecase(use)}`;
  return {
    provide,
    [useKey]: value,
    multi
  };
}
function randomid() {
  return window.crypto.randomUUID();
}
function nativeElement(el$) {
  return el$.nativeElement;
}
function assign(...args) {
  return Object.assign({}, ...args);
}
function redirectTo(url, target = '_blank') {
  const link$ = document.createElement('a');
  link$.setAttribute('href', url);
  link$.setAttribute('target', target);
  link$.click();
}
function isValidDate(date) {
  if (isNullish(date)) return false;
  const toDate = +new Date(date);
  return !Number.isNaN(toDate);
}
function copyDate(date) {
  return new Date(date);
}
function getWeekDays(type, date = new Date()) {
  date = copyDate(date);
  const firstWeekDay = 1;
  const lastWeekDay = 7;
  const currentDay = date.getDay() || lastWeekDay;
  const days = [];
  const isNotFirstWeekDay = date.getDay() !== firstWeekDay;
  if (isNotFirstWeekDay) {
    date.setDate(date.getDate() - (currentDay - 1));
  }
  if (type === 'previous-week') {
    date.setDate(date.getDate() - lastWeekDay);
  }
  while (days.length < 7) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  if (type === 'current-week') {
    days.splice(currentDay);
  }
  return days;
}
function getFirstAndLastElements(array) {
  const firstElement = array[0];
  const lastElement = array.length >= 1 ? array.at(-1) : null;
  return [firstElement, lastElement];
}
function getNextSortDirection(sortDir) {
  switch (sortDir) {
    case '':
      {
        return 'asc';
      }
    case 'asc':
      {
        return 'desc';
      }
    case 'desc':
      {
        return '';
      }
  }
}
function excludeObjValues(obj, values = ['', null, undefined]) {
  return Object.entries(obj).reduce((accum, [key, value]) => {
    if (values.includes(value)) return accum;
    accum[key] = value;
    return accum;
  }, {});
}
function excludeObjProps(object, keys) {
  return Object.entries(object).reduce((accum, [key, value]) => {
    const isCanAddProperty = !keys.includes(key);
    if (isCanAddProperty) {
      accum[key] = value;
    }
    return accum;
  }, {});
}
function excludeEmptyProps(obj) {
  return Object.entries(obj).reduce((accum, [key, value]) => {
    const isDefinedValue = !isNullish(value);
    if (isDefinedValue) {
      accum[key] = value;
    }
    return accum;
  }, {});
}
function pickEqualProps(parent, child) {
  return Object.keys(parent).reduce((accum, key) => {
    if (key in child) {
      accum[key] = child[key];
    }
    return accum;
  }, {});
}
function selectObjectProps(object, props) {
  return props.reduce((accum, key) => {
    if (key in object) accum[key] = object[key];
    return accum;
  }, {});
}
function setObjectValues(object, value) {
  return Object.entries(object).reduce((accum, [key]) => {
    accum[key] = value;
    return accum;
  }, {});
}
function findIndexByProp(items, prop, value) {
  return items.findIndex(curr => curr[prop] === value);
}
function removeItemByProp(items, item, prop) {
  return items.filter(curr => curr[prop] !== item[prop]);
}
function removeItem(items, item) {
  return items.filter(curr => curr !== item);
}
function updateItem(items, item, prop) {
  const currentIdx = findIndexByProp(items, prop, item[prop]);
  if (~currentIdx) {
    const updatedItem = assign(items[currentIdx], item);
    items[currentIdx] = updatedItem;
    return items.concat();
  }
  return items;
}
function findAndMergeItems(newItems, currentItems, prop) {
  currentItems = currentItems.concat();
  newItems.forEach(item => {
    const idx = findIndexByProp(currentItems, prop, item[prop]);
    if (~idx) {
      currentItems[idx] = assign(currentItems[idx], item);
    }
  });
  return currentItems;
}
function createRangeArray(from, to) {
  const length = to - from;
  return Array.from({
    length
  }, (v, i) => from + i);
}
function toFixed(num, fixed) {
  num = String(num);
  const isFractional = String(num).includes('.');
  if (!isFractional) return Number(num);
  const [integer, float] = num.split('.');
  if (fixed === 0) {
    return Number(integer);
  }
  const slicedFloatValue = float.slice(0, fixed);
  const value = `${integer}.${slicedFloatValue}`;
  return Number(value);
}
function sumNumber(a, b, action) {
  const isFloat = !Number.isInteger(b);
  if (isFloat) {
    a = +(a * 100).toFixed(0);
    b = +(b * 100).toFixed(0);
  }
  const value = action === 'inc' ? a + b : a - b;
  return isFloat ? value / 100 : value;
}
function toTag(str) {
  return `{{${str}}}`;
}
function replaceTags(str, tagsObj) {
  if (isNullish(str) || isNullish(tagsObj)) return str;
  return Object.entries(tagsObj).reduce((accum, [key, value]) => {
    const regex = new RegExp(toTag(key), 'gi');
    if (isJSType(value, 'function')) value = value();
    return accum.replace(regex, value);
  }, str);
}
function getEnumMap(enumObj) {
  const enumSerialize = Object.values(enumObj);
  const enumMap = {
    keys: [],
    values: []
  };
  for (const key of enumSerialize) {
    const value = enumObj[key];
    const isEndCycle = enumMap.keys.includes(value);
    if (isEndCycle) break;else {
      enumMap.keys.push(key);
      enumMap.values.push(value);
    }
  }
  return enumMap;
}
function wrapToArray(value) {
  const array = [];
  return array.concat(value);
}
function serializeSimpleChanges(changes) {
  return Object.entries(changes).reduce((accum, [key, simpleChanges]) => {
    accum[key] = simpleChanges.currentValue;
    return accum;
  }, {});
}
function fillObject(obj, value) {
  return Object.entries(obj).reduce((accum, [key]) => {
    accum[key] = value;
    return accum;
  }, {});
}
function recordObject(fields, value) {
  return fields.reduce((accum, field) => {
    accum[field] = value;
    return accum;
  }, {});
}
function makeReadonlySignal(signal) {
  return isWritableSignal(signal) ? signal.asReadonly() : signal;
}

/**
 * Ключи карты:
 * 'default': соответствует слову noda.
 * 'company': соответствует слову nauda.
 */
const DEFAULT_SECRET_MAP = new Map([['default', 'bm9kYQ=='], ['company', 'bmF1ZGE=']]);
function createSecretReplacer(customMap) {
  function useSecret(word, textTransform = 'lowercase') {
    const secretWord = customMap.get(word);
    let result;
    if (typeof window !== 'undefined') {
      result = window.atob(secretWord);
    } else {
      // ! Опасный момент, если будет падать, то переписать на нативную реализацию, можно забрать полифилы для btoa и atob. Пока фиксится при помощи angularCompilerOptions: { "types": ["node"]  }
      result = Buffer.from(secretWord, 'base64').toString();
    }
    switch (textTransform) {
      case 'lowercase':
        return result.toLocaleLowerCase();
      case 'capitalize':
        return result.charAt(0).toUpperCase() + result.slice(1);
      case 'uppercase':
        {
          return result.toLocaleUpperCase();
        }
    }
  }
  function secretReplacer(value, word, textTransform = 'lowercase') {
    const tags = {
      secret: useSecret(word, textTransform)
    };
    return replaceTags(value, tags);
  }
  return {
    useSecret,
    secretReplacer
  };
}
const {
  useSecret,
  secretReplacer
} = createSecretReplacer(DEFAULT_SECRET_MAP);

/**
 * Generated bundle index. Do not edit.
 */

export { DIProvider, addPrefixIfNot, arraysIsContain, assign, condition, copyDate, createRangeArray, createSecretReplacer, deepCopy, deepCopyArray, excludeEmptyProps, excludeObjProps, excludeObjValues, fillObject, findAndMergeItems, findIndexByProp, getDataFromDB, getEnumMap, getFirstAndLastElements, getNextSortDirection, getWeekDays, isDate, isEmptyObject, isEqual, isEqualJSON, isEqualStrings, isEveryJSType, isExistAllObjectFields, isExistSomeFieldInObject, isInstance, isJSType, isNotNullish, isNullish, isObject, isValidDate, isWritableSignal, joinUrl, lowercase, makeReadonlySignal, nativeElement, ofType, pickEqualProps, prefix, randomid, recordObject, redirectTo, removeItem, removeItemByProp, removeSideSymbols, removeSpaces, removeSymbols, replace, replaceTags, secretReplacer, selectObjectProps, serializeSimpleChanges, setObjectValues, sliceStringToSegments, suffix, sumNumber, testIncludeWord, titlecase, toFixed, toTag, trim, trimStringValues, updateItem, useSecret, wrapString, wrapToArray };
